module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addCurrency
    }
  }, [_vm._v("增加积分配置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.currencyList,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yw_name",
      "label": "业务名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "params",
      "label": "调用参数配置"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "every_day_max",
      "label": "每人派送积分最大量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.createtime, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updatetime",
      "label": "更新时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.updatetime, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enable_flag",
      "label": "是否启用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": scope.row.enable_flag ? true : false
          },
          model: {
            value: (scope.row.enable_flag),
            callback: function($$v) {
              _vm.$set(scope.row, "enable_flag", $$v)
            },
            expression: "scope.row.enable_flag"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "220px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "业务名称",
        "prop": "yw_name"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "业务名称 如 看视频送积分"
      },
      model: {
        value: (_vm.form.yw_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "yw_name", $$v)
        },
        expression: "form.yw_name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "调用参数配置",
        "prop": "params"
      }
    }, [(_vm.editflag) ? _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": "",
        "placeholder": "拼音格式 如 kspsjf 推荐设置为业务名称的拼音,不可修改"
      },
      model: {
        value: (_vm.form.params),
        callback: function($$v) {
          _vm.$set(_vm.form, "params", $$v)
        },
        expression: "form.params"
      }
    })], 1) : _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "拼音格式 如 kspsjf 推荐设置为业务名称的拼音,不可修改"
      },
      model: {
        value: (_vm.form.params),
        callback: function($$v) {
          _vm.$set(_vm.form, "params", $$v)
        },
        expression: "form.params"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "业务说明",
        "prop": "yw_desc"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "业务说明"
      },
      model: {
        value: (_vm.form.yw_desc),
        callback: function($$v) {
          _vm.$set(_vm.form, "yw_desc", $$v)
        },
        expression: "form.yw_desc"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "每天每人派送积分最大量",
        "prop": "every_day_max",
        "type": "number"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 50
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "每天每人派送积分最大量"
      },
      model: {
        value: (_vm.form.every_day_max),
        callback: function($$v) {
          _vm.$set(_vm.form, "every_day_max", $$v)
        },
        expression: "form.every_day_max"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "是否启用",
        "prop": "enable_flag"
      }
    }, [_c('el-switch', {
      attrs: {
        "width": 50,
        "active-value": "true",
        "inactive-value": "false",
        "active-text": "开启",
        "inactive-text": "关闭",
        "active-color": "#13ce66"
      },
      model: {
        value: (_vm.form.enable_flag),
        callback: function($$v) {
          _vm.$set(_vm.form, "enable_flag", $$v)
        },
        expression: "form.enable_flag"
      }
    })], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitAction
      }
    }, [_vm._v("保存")])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a6a2dd72", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6a2dd72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/nppoint/index.vue
// module id = 2899
// module chunks = 0